<template>
  <div class="az-form-content">
    <div v-if="isPossuiResultados">
      <listagem-resultado :itens="itens"
                          :paginas="paginas"
                          :total-itens="totalItens"
                          :paginacao="$store.state.resultadoSolicitacaoCredenciamento.paginacao"
                          @paginar="eventoPaginarResultado"
                          @buscar-solicitacoes="buscarSolicitacoes">
      </listagem-resultado>
    </div>
    <div v-else>
      <credenciamento-fornecedor-resultado-vazio></credenciamento-fornecedor-resultado-vazio>
    </div>
  </div>
</template>

<script>

import ListagemResultado from './resultado/ListagemResultado.vue'
import CredenciamentoFornecedorResultadoVazio
  from "@/views/credenciamento/detalhe-credenciamento/fornecedor/resultado/CredenciamentoFornecedorResultadoVazio.vue";
import {mapActions, mapState, mapMutations} from "vuex";
import {actionTypes, mutationTypes} from "@/commons/constants";

export default {
  name: 'CredenciamentoFornecedorResultado',
  components: {ListagemResultado, CredenciamentoFornecedorResultadoVazio},
  data() {
    return {
      licitacaoId: null,
      isPossuiResultados: false,
      analiseSolicitacaoCredenciamentoEmAnalise: null,
      paginas: 0,
      totalItens: 0,
      itens: []
    }
  },
  async mounted() {
    this.habilitarLoadingGlobal()
    this.licitacaoId = this.$route.params.id
    await this.buscarSolicitacoes()
    this.desabilitarLoadingGlobal()
  },
  methods: {
    async buscarSolicitacoes() {
      this.habilitarLoadingGlobal()
      this.setMensagemLoading('Carregando Solicitações Credenciamento...')
      const resultado = await this.buscarResultadosSolicitacoesCredenciamento(this.licitacaoId)
      this.isPossuiResultados = resultado.totalElements > 0
      if (this.isPossuiResultados) {
        this.itens = resultado.solicitacoes
        this.paginas = resultado.totalPages
        this.totalItens = resultado.totalElements
      }
      this.desabilitarLoadingGlobal()
    },
    eventoPaginarResultado(paginacao) {
      this.setPaginacaoResultado(paginacao)
      this.buscarSolicitacoes()
    },
    ...mapActions({
      buscarResultadosSolicitacoesCredenciamento: actionTypes.CREDENCIAMENTO.SOLICITACAO.BUSCAR_RESULTADOS_SOLICITACOES_CREDENCIAMENTO,
    }),
    ...mapMutations({
      setPaginacaoResultado: mutationTypes.CREDENCIAMENTO.SET_PAGINACAO_RESULTADO,
    })
  },
  computed: {
    ...mapState(['licitacao']),
  },
}
</script>
